export default __webpack_public_path__ + "static/media/delete-icon-golden.8ff3f0bb.svg";